import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA036_Request,
  IAPI_STA036_Response,
} from "../../../type/apiType";

// 「俸給の調整額」対象手当申請参照
const httpAPI_STA036 = async (
  param: IAPI_STA036_Request
): Promise<IAPI_STA036_Response> => {
  let res = await http.post(ApiUrl.API_STA036, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA036 };
